

import React, { useEffect, useState } from 'react';
import CrmEmpty from "../CrmEmpty";
import { Table, Space, Button, Input, Spin, Tabs, Pagination, Row, Col } from 'antd';
import moment from 'moment-jalaali';
import strings from '../../../../utils/strings';
import { SearchOutlined, ZoomInOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import InsuranceDetails from "../../../shared/insuranceDetails/InsuranceDetails";
import { useGeneralStore } from '../../../../store/slices/createGeneralSlice';
import { useReportsStore } from '../../../../store/slices/createReportsSlice';

const { TabPane } = Tabs;


export default function CrmrequestReport({ usrUserID, category, pageSize }) {


    const [requestId, setRequestId] = useState();
    const [applicantUserId, setApplicantUserId] = useState();
    const [paymentInfo, setPaymentInfo] = useState(null);
    const [insuranceRequestIdSearch, setInsuranceRequestIdSearch] = useState("");
    const [trackingCodeSearch, setTrackingCodeSearch] = useState("");
    const [page, setPage] = useState(1);
    const [categoryLatinTitle, setcategoryLatinTitle] = useState(1);
    const general = useGeneralStore();
    const reports = useReportsStore()
    const loading = reports.crmRequestReport.loading;
    const [tabsId, setTabsId] = useState("0");
    const rawData = reports.crmRequestReport.data;
    const data = Array.isArray(rawData) ? rawData : rawData?.Items;
    // If it's an array, we don't know the exact total. We fake it to allow next page if it's full.
    const total = Array.isArray(rawData) ? (page - 1) * pageSize + rawData.length + (rawData.length === pageSize ? 1 : 0) : rawData?.Total;
    const visible = general.view.crmReportModal;

    const promoterVisible = general.view.promoterUserModal;


    // const statusNameFilter = [...new Set(requestDetails && requestDetails?.map(item => item.StatusTitle))];
    const statusNameFilter = [
        "پرداخت نشده",
        "صف صدور",
        "صادر شده",
        "رد و فسخ"

    ]





    useEffect(() => {
        if (usrUserID || category === 1 || visible || promoterVisible) {
            setTabsId("0");
            setPage(1);
            setcategoryLatinTitle(1);
            setInsuranceRequestIdSearch("");
            setTrackingCodeSearch("");

        }
    }, [usrUserID, category, visible, promoterVisible]);


    function tabIdSetter(key) {
        setTabsId(key);
        setInsuranceRequestIdSearch("");
        setTrackingCodeSearch("");
        setPage(1);
        let categoryVal = 1;
        switch (key) {
            case "0":
                categoryVal = 1; break;
            case "1":
                categoryVal = 2; break;
            case "2":
                categoryVal = 3; break;
            case "3":
                categoryVal = 4; break;
            default:
                break;
        }
        setcategoryLatinTitle(categoryVal);
        reports.getCrmRequestReport({
            usrUserID: usrUserID,
            PageSize: pageSize,
            PageNumber: 1,
            CategoryPaymentStatus: categoryVal,
        });
    }

    const pageChange = (page, pageSize) => {
        setPage(page)

        reports.getCrmRequestReport({
            usrUserID: usrUserID,
            PageSize: pageSize,
            PageNumber: page,
            CategoryPaymentStatus: categoryLatinTitle,
        });

    }
    const columns = [
        {
            title: "جزئیات بیمه نامه",
            dataIndex: "operation",
            key: "operation",
            width: 85,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
                            setRequestId(record.InsuranceRequestId);
                            general.ToggleInsuranceDetailsModal();
                            setApplicantUserId(record.ApplicantUserId);
                            setPaymentInfo({
                                ActualAmount: record.ActualAmount,
                                PayableAmount: record.PayableAmount,
                                AgreementDiscountAmount: record.AgreementDiscountAmount,
                            });
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "وضعیت",
            dataIndex: "StatusTitle",
            key: "StatusTitle",
            width: 130,
        },
        {
            title: "آی دی",
            dataIndex: "InsuranceRequestId",
            width: 70,
            key: "InsuranceRequestId",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "کد رهگیری",
            dataIndex: "TrackingCode",
            key: "TrackingCode",
            width: 120,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.TrackingCode ? (first = a.TrackingCode) : (first = "");
                b.TrackingCode ? (second = b.TrackingCode) : (second = "");
                return first.localeCompare(second);
            },
            render: text => text && text.toUpperCase().replace('BM-', '')
        },
        {
            title: "نام بیمه گزار",
            dataIndex: "PolicyOwnerFullName",
            key: "PolicyOwnerFullName",
            width: 110,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PolicyOwnerFullName ? (first = a.PolicyOwnerFullName) : (first = "");
                b.PolicyOwnerFullName ? (second = b.PolicyOwnerFullName) : (second = "");
                return first.localeCompare(second);
            },
            render: text => text && strings.getFarsiNum(text),
        },
        {
            title: "نام درخواست کننده",
            dataIndex: "ApplicantFullName",
            key: "ApplicantFullName",
            width: 140,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.ApplicantFullName ? (first = a.ApplicantFullName) : (first = "");
                b.ApplicantFullName ? (second = b.ApplicantFullName) : (second = "");
                return first.localeCompare(second);
            },
            render: text => text && strings.getFarsiNum(text),
        },
        {
            title: "رشته",
            dataIndex: "BranchTitle",
            key: "BranchTitle",
            width: 100,
        },
        {
            title: "شرکت",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 100,
        },
        {
            title: "مبلغ کل",
            dataIndex: "ActualAmount",
            key: "ActualAmount",
            width: 120,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ قابل پرداخت",
            dataIndex: "PayableAmount",
            key: "PayableAmount",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "تخفیف توافقی",
            dataIndex: "AgreementDiscountAmount",
            key: "AgreementDiscountAmount",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "تاریخ ثبت",
            dataIndex: "CreationTime",
            key: "CreationTime",
            width: 100,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.CreationTime ? first = a.CreationTime : first = '';
                b.CreationTime ? second = b.CreationTime : second = '';
                return first.localeCompare(second)
            },
            render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        }
    ];
    const tableContent = (
        <>
            <div style={{ marginBottom: 16, marginTop: 8 }}>
                <Row gutter={[8]}   >
                    <Col span={6}  >
                        <Input
                            placeholder="جستجو بر اساس آی‌دی  یا کد رهگیری"
                            value={insuranceRequestIdSearch || trackingCodeSearch}
                            onChange={e => {
                                const value = e.target.value.trim();
                                if (/^\d+$/.test(value)) {
                                    setInsuranceRequestIdSearch(value);
                                    setTrackingCodeSearch("");
                                } else {
                                    setTrackingCodeSearch(value);
                                    setInsuranceRequestIdSearch("");
                                }
                            }}

                            allowClear
                        /></Col>
                    <Col span={8} >
                        <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    let params = {
                                        usrUserID,
                                        PageSize: pageSize,
                                        PageNumber: 1,
                                        CategoryPaymentStatus: categoryLatinTitle,
                                    };
                                    if (insuranceRequestIdSearch) params.InsuranceRequestId = Number(insuranceRequestIdSearch);
                                    if (trackingCodeSearch) params.TrackingCode = trackingCodeSearch;
                                    reports.getCrmRequestReport(params);
                                    setPage(1);
                                }}
                            >
                                جستجو
                            </Button>
                            <Button
                                onClick={() => {
                                    setInsuranceRequestIdSearch("");
                                    setTrackingCodeSearch("");
                                    reports.getCrmRequestReport({
                                        usrUserID,
                                        PageSize: pageSize,
                                        PageNumber: 1,
                                        CategoryPaymentStatus: categoryLatinTitle,
                                    });
                                    setPage(1);
                                }}
                            >
                                ریست
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
            {data && data.length > 0 ? <>
                <Table
                    style={{ overflowX: 'scroll' }}
                    size="small"
                    className="custom-table crm-table crm-request-report "
                    bordered
                    loading={loading}
                    rowKey="InsuranceRequestId"
                    scroll={true}
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                />
                <Pagination
                    defaultCurrent={1}
                    current={page}
                    onChange={pageChange}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger={false} />
            </>
                :
                <CrmEmpty text="درخواست یافت نشد" />}
        </>
    );
    return (
        <div className='crm-request-report'>
            <Spin spinning={loading}>
                <Tabs
                    activeKey={tabsId}
                    onChange={tabIdSetter}
                    centered
                    destroyInactiveTabPane
                >
                    {statusNameFilter?.map((status, index) => (
                        <TabPane key={String(index)} tab={status}>
                            {tableContent}
                        </TabPane>
                    ))}
                </Tabs>
                <InsuranceDetails requestId={requestId} applicantUserId={applicantUserId} paymentInfo={paymentInfo} />
            </Spin>
        </div>
    )
}